// Common JS - loaded on all pages
import handleMobileMenu from './mobileMenu';
import handleStickyHeader from './stickyHeader';
import handleBodyClasses from './handleBodyClasses';
import objectFitPolyfill from './objectFitPolyfill';
import customFunctions from './customFunctions';
import accordion from './accordion';
import YoastAccordions from './../../plugins/accordionYoast';

export default {
  /**
   * Runs first before any JS
   */
  init: () => {
    handleBodyClasses();
    handleStickyHeader();
    handleMobileMenu();
    customFunctions();
    accordion();
    console.log('Common Init JS Loaded');
  },
  complete: () => {
    const { fn: { getOptions, loadJs }, contentDirectory } = am2;
    
    objectFitPolyfill();

    // Covert Yoast FAQ to accordions - runs last, not needed asap
    const accordion = [...document.querySelectorAll('.wp-block-yoast-faq-block')];
    for (let i = 0; i < accordion.length; i++) {
      YoastAccordions(accordion[i], getOptions(accordion[i].dataset.options));
    }

    // select to jquery ui select menu
    jQuery( '.filters-search select, .custom-select-js' ).selectmenu();
    /*** read-more-toggle add class to the parent when clicked ***/
    // vars
    var readMoreToggle = jQuery( '.read-more-toggle' );
    var contentArea = jQuery( '.read-more-toggle__text-area' );
    // hide read more button initialy
    readMoreToggle.hide();
    // if the content area is larger than 250 set the height to 250 and show read more button
    if( contentArea.height() > 250 ) {
      // show read more button
      readMoreToggle.fadeIn();
      // set content area to 250px fixed
      contentArea.addClass( 'more_than_250 ');
      contentArea.css( 'height', '250px' );
      // show/hide extra content
      readMoreToggle.on( 'click', function() {
        var elToAnimate = $( this ).parent().find( '.read-more-toggle__text-area' );
        $( this ).parent().toggleClass( 'expanded' );
        if( $( this ).parent().hasClass( 'expanded' ) ) {
          elToAnimate.animate({
              height: elToAnimate.get( 0 ).scrollHeight
          }, 100 )
        }
        if( !$( this ).parent().hasClass( 'expanded' ) ) {
          elToAnimate.animate({
              height: 250
          }, 100 )
        }
      });
    }

    // switch newsletter mailchimp form id when switching cities in a dropdown
    jQuery( '.newsletter-form__custom-select select' ).selectmenu({
      change: function ( event, data ) {
        var city_mailchimp_id = jQuery( this ).val();
        jQuery( '.newsletter-form__form input[name="id"]' ).val( city_mailchimp_id );
        return false;
      }
    });

    // remove inline style of accordion element in order to style it better
    jQuery( '.place-single .accordion__content > div:nth-child(odd) > span' ).removeAttr( 'style' );
    
    //console.log('Common Complete JS Loaded');
  },
};
